import React from 'react';

const DIAS = [
  { key: 'lunes', label: 'Lunes' },
  { key: 'martes', label: 'Martes' },
  { key: 'miercoles', label: 'Miércoles' },
  { key: 'jueves', label: 'Jueves' },
  { key: 'viernes', label: 'Viernes' },
];

const getInitials = (apellido = '') =>
  apellido
    .trim()
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0] || '')
    .join('')
    .toUpperCase();

const IconAlert = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
);

const VirtualLink = ({ texto }) => {
  if (!texto || !texto.trim()) return null;
  const t = texto.trim();
  if (t.toLowerCase().startsWith('http')) {
    return (
      <a href={t} className="hcd-link" target="_blank" rel="noreferrer">
        {t}
      </a>
    );
  }
  return <span className="hcd-lugar-text">{t}</span>;
};

const ConsuCards = ({ matdocentes = [], mat = '' }) => {
  const formatearActividad = (ele) => {
    const materia = ele?.materia?.trim?.() || '';
    const idActividad = ele?.id_mat ? String(ele.id_mat).trim() : '';

    if (!materia && !idActividad) return '';
    if (!materia) return idActividad;
    if (!idActividad) return materia;

    return `${materia} (${idActividad})`;
  };

  if (!matdocentes.length) return null;

  return (
    <>
      <div className="hcd-activity-header">
        <span className="hcd-activity-title">{mat}</span>
        <span className="hcd-count-badge">
          {matdocentes.length} registro{matdocentes.length > 1 ? 's' : ''}
        </span>
      </div>

      <div className="hcd-cards-grid">
        {matdocentes.map((ele, ind) => {
          const diasActivos = DIAS.filter((d) => ele[d.key] && ele[d.key].trim().length > 2);
          const hasNovedad = ele.novedad && ele.novedad.trim().length > 0;
          const hasLugar = ele.lugar_c && ele.lugar_c.trim().length > 0;
          const hasVirtual = ele.lugar_v && ele.lugar_v.trim().length > 0;
          const actividadTexto = formatearActividad(ele);
          const hasMateria = actividadTexto.length > 0;

          return (
            <div className="hcd-card" key={ele.id_hora ?? `${ele.id_mat ?? 'sinmat'}-${ind}`}>
              <div className="hcd-card-head">
                <div className="hcd-avatar">{getInitials(ele.apellido)}</div>
                <div className="hcd-card-name">{ele.apellido ? ele.apellido.trim() : '—'}</div>
              </div>

              <div className="hcd-card-body">
                {hasMateria && (
                  <>
                    <div className="hcd-section-label">Actividad</div>
                    <div className="hcd-lugar-text">{actividadTexto}</div>
                  </>
                )}

                {hasNovedad && (
                  <div className="hcd-novedad-tag">
                    <IconAlert />
                    <span>{ele.novedad.trim()}</span>
                  </div>
                )}

                {diasActivos.length > 0 ? (
                  <>
                    <div className="hcd-section-label">Días y horarios</div>
                    <div className="hcd-schedule-list">
                      {diasActivos.map((d) => (
                        <div className="hcd-day-row" key={d.key}>
                          <span className="hcd-day-name">{d.label}</span>
                          <span className="hcd-day-time">{ele[d.key].trim()}</span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <div className="hcd-section-label" style={{ marginTop: 0 }}>
                    Sin horario cargado
                  </div>
                )}

                {hasLugar && (
                  <>
                    <div className="hcd-section-label">Lugar presencial</div>
                    <div className="hcd-lugar-text">{ele.lugar_c.trim()}</div>
                  </>
                )}

                {hasVirtual && (
                  <>
                    <div className="hcd-section-label">Consulta virtual</div>
                    <VirtualLink texto={ele.lugar_v} />
                  </>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ConsuCards;